import { combineReducers } from 'redux';
import { simpleReducer } from '@mgc/map-client-shared/lib/ReduxTools';
import actions from '../actions';

export default combineReducers({
    offers: simpleReducer([], {
        RECEIVED_OFFERS: (a) => a.payload.response,
    }),

    selectedOfferIndex: (state = -1, action) => {
        switch (action.type) {
            case actions.RECEIVED_OFFERS:
                if (-1 < state && state < action.payload.response.length) {
                    return state;
                }
                if (action.payload.response.length > 0) {
                    return 0;
                }
                return -1;

            case actions.SELECT_OFFER:
                return action.payload.offerIndex;

            default:
                return state;
        }
    },

    offersRetrieved: simpleReducer(false, {
        RECEIVED_OFFERS: true,
        REQUESTING_OFFERS: false,
    }),

    selectedProductIndex: simpleReducer(-1, {
        SELECT_PRODUCT: (a) => a.payload.productIndex,
        START_JOYRIDE: 0,
        FINISH_JOYRIDE: -1,
        CANCEL_JOYRIDE: -1,
    }),
});



// WEBPACK FOOTER //
// ./app/reducers/offer.js